// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  width: 190mm;
  margin: 0px auto;
  page-break-after: always;
  font-family: Roboto, "LiberationSerif", serif;
  -webkit-text-size-adjust: none;
}

.row0 {
  clear: both;
  height: 0px;
  border: 1px solid black;
  border-top: 0px;
}

.row1 {
  clear: both;
  height: 16px;
  border: 1px solid black;
  border-top: 0px;
}

.row2 {
  clear: both;
  height: 32px;
  border: 1px solid black;
  border-top: 0px;
}

.row3 {
  clear: both;
  height: 48px;
  border: 1px solid black;
  border-top: 0px;
}

.row3_job {
  height: 39px;
}

.row4 {
  clear: both;
  height: 64px;
  border: 1px solid black;
  border-top: 0px;
}

.row4_rest {
  height: 68px;
}

.inline_grid {
  border-spacing: 0px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  height: 100%;
}

.inline_column {
  padding: 0px;
}

.inline_column_tiny {
  padding: 0px;
  width: 30px;
}

.inline_column_huge {
  padding: 0px;
  width: 150px;
}

.inline_column50 {
  padding: 0px;
  width: 50%;
}

.center {
  text-align: center;
}

.border_all {
  border: 1px solid black;
}

.border_left {
  border-left: 1px solid black;
}

.border_top {
  border-top: 1px solid black;
}

.title1 {
  line-height: 20px;
  font-size: 16px;
}

.title2 {
  line-height: 20px;
  font-size: 10px;
  text-decoration: overline;
  position: absolute;
  z-index: 1;
  left: 80px;
  top: -10px;
}

.title3 {
  line-height: 20px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.title4 {
  font-size: 10px;
  font-weight: bold;
  text-align: center;
}

.title5 {
  margin-top: 4px;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: bold;
}

.title6 {
  font-size: 12px;
  font-weight: bold;
}

.title7 {
  line-height: 20px;
  font-size: 10px;
  text-align: right;
}

.system {
  table-layout: auto;
  border: 3px double black;
  border-collapse: collapse;
  margin-top: 10px;
}

.system_small {
  table-layout: auto;
  border: 3px double black;
  border-collapse: collapse;
}

.caption {
  height: 100%;
  line-height: 16px;
  font-size: 10px;
  letter-spacing: -0.1px;
  overflow: hidden;
}

.condensed3 {
  letter-spacing: -0.3px;
}

.condensed7 {
  letter-spacing: -0.7px;
}

.field {
  background-color: AliceBlue;
  height: 100%;
  line-height: 16px;
  font-size: 14px;
  overflow: hidden;
}

.field_job {
  line-height: 13px;
  font-size: 11px;
}

.line1 {
  height: 16px;
}

.line2 {
  height: 32px;
}

.line3 {
  height: 48px;
}

.line3_job {
  height: 39px;
}

.check_intro {
  float: left;
}

.check_value {
  background-color: AliceBlue;
  float: left;
  width: 12px;
  height: 12px;
  line-height: 12px;
  border: 1px solid gray;
  margin: 1px;
  text-align: center;
}

.inet_qr_parent {
  position: relative;
}

.inet_qr {
  position: absolute;
}

.photo {
  border: 1px solid black;
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 105px;
  height: 140px;
  background: white;
}

.printPhoto {
  width: 103px;
  height: 138px;
  object-fit: contain;
}

.sig1 {
  border: 1px solid black;
  height: 75px;
}

.sig2 {
  border: 2px solid black;
  height: 75px;
}

.left {
  float: left;
  border-right: 1px solid black;
}

.right {
  float: right;
  border-left: 1px solid black;
}

.fixed {
  padding-left: 4px;
  padding-right: 4px;
}

.fixed_tiny {
  padding-left: 4px;
  padding-right: 4px;
  width: 30px;
}

.fixed_small {
  padding-left: 4px;
  padding-right: 4px;
  width: 60px;
}

.right.fixed_small.field {
  padding-right: 12px;
}

.fixed_medium {
  padding-left: 4px;
  padding-right: 4px;
  width: 90px;
}

.fixed_large {
  padding-left: 4px;
  padding-right: 4px;
  width: 120px;
}

.fixed_huge {
  padding-left: 4px;
  padding-right: 4px;
  width: 150px;
}

.greedy {
  padding-left: 4px;
  padding-right: 4px;
  overflow: hidden;
}

.statement_number {
  padding-top: 2px;
  font-size: 14px;
  position: relative;
}

.statement_left {
  position: absolute;
  left: 0;
  bottom: 0;
}

.statement_center {
  position: relative;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
}

.statement_right {
  position: absolute;
  right: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/model/print-web/view/adult-request-form-v2/adult-request-form-v2.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,6CAAA;EACA,8BAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,2BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AACJ;;AACA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAEJ;;AACA;EACI,uBAAA;EACA,YAAA;AAEJ;;AACA;EACI,uBAAA;EACA,YAAA;AAEJ;;AACA;EACI,WAAA;EACA,6BAAA;AAEJ;;AACA;EACI,YAAA;EACA,4BAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;AAEJ;;AACA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAEJ","sourcesContent":[".page {\n    width: 190mm;\n    margin: 0px auto;\n    page-break-after: always;\n    font-family: Roboto, \"LiberationSerif\", serif;\n    -webkit-text-size-adjust: none;\n}\n\n.row0 {\n    clear: both;\n    height: 0px;\n    border: 1px solid black;\n    border-top: 0px;\n}\n\n.row1 {\n    clear: both;\n    height: 16px;\n    border: 1px solid black;\n    border-top: 0px;\n}\n\n.row2 {\n    clear: both;\n    height: 32px;\n    border: 1px solid black;\n    border-top: 0px;\n}\n\n.row3 {\n    clear: both;\n    height: 48px;\n    border: 1px solid black;\n    border-top: 0px;\n}\n\n.row3_job {\n    height: 39px;\n}\n\n.row4 {\n    clear: both;\n    height: 64px;\n    border: 1px solid black;\n    border-top: 0px;\n}\n\n.row4_rest {\n    height: 68px;\n}\n\n.inline_grid {\n    border-spacing: 0px;\n    border-collapse: collapse;\n    table-layout: fixed;\n    width: 100%;\n    height: 100%;\n}\n\n.inline_column {\n    padding: 0px;\n}\n\n.inline_column_tiny {\n    padding: 0px;\n    width: 30px;\n}\n\n.inline_column_huge {\n    padding: 0px;\n    width: 150px;\n}\n\n.inline_column50 {\n    padding: 0px;\n    width: 50%;\n}\n\n.center {\n    text-align: center;\n}\n\n.border_all {\n    border: 1px solid black;\n}\n\n.border_left {\n    border-left: 1px solid black;\n}\n\n.border_top {\n    border-top: 1px solid black;\n}\n\n.title1 {\n    line-height: 20px;\n    font-size: 16px;\n}\n\n.title2 {\n    line-height: 20px;\n    font-size: 10px;\n    text-decoration: overline;\n    position: absolute;\n    z-index: 1;\n    left: 80px;\n    top: -10px;\n}\n\n.title3 {\n    line-height: 20px;\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.title4 {\n    font-size: 10px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.title5 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    font-size: 10px;\n    font-weight: bold;\n}\n\n.title6 {\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.title7 {\n    line-height: 20px;\n    font-size: 10px;\n    text-align: right;\n}\n\n.system {\n    table-layout: auto;\n    border: 3px double black;\n    border-collapse: collapse;\n    margin-top: 10px;\n}\n\n.system_small {\n    table-layout: auto;\n    border: 3px double black;\n    border-collapse: collapse;\n}\n\n.caption {\n    height: 100%;\n    line-height: 16px;\n    font-size: 10px;\n    letter-spacing: -0.1px;\n    overflow: hidden;\n}\n\n.condensed3 {\n    letter-spacing: -0.3px;\n}\n\n.condensed7 {\n    letter-spacing: -0.7px;\n}\n\n.field {\n    background-color: AliceBlue;\n    height: 100%;\n    line-height: 16px;\n    font-size: 14px;\n    overflow: hidden;\n}\n\n.field_job {\n    line-height: 13px;\n    font-size: 11px;\n}\n\n.line1 {\n    height: 16px;\n}\n\n.line2 {\n    height: 32px;\n}\n\n.line3 {\n    height: 48px;\n}\n\n.line3_job {\n    height: 39px;\n}\n\n.check_intro {\n    float: left;\n}\n\n.check_value {\n    background-color: AliceBlue;\n    float: left;\n    width: 12px;\n    height: 12px;\n    line-height: 12px;\n    border: 1px solid gray;\n    margin: 1px;\n    text-align: center;\n}\n\n.inet_qr_parent {\n    position: relative;\n}\n\n.inet_qr {\n    position: absolute;\n}\n\n.photo {\n    border: 1px solid black;\n    position: absolute;\n    right: -1px;\n    bottom: -1px;\n    width: 105px;\n    height: 140px;\n    background: white;\n}\n.printPhoto {\n    width: 103px;\n    height: 138px;\n    object-fit: contain;\n}\n\n.sig1 {\n    border: 1px solid black;\n    height: 75px;\n}\n\n.sig2 {\n    border: 2px solid black;\n    height: 75px;\n}\n\n.left {\n    float: left;\n    border-right: 1px solid black;\n}\n\n.right {\n    float: right;\n    border-left: 1px solid black;\n}\n\n.fixed {\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.fixed_tiny {\n    padding-left: 4px;\n    padding-right: 4px;\n    width: 30px;\n}\n\n.fixed_small {\n    padding-left: 4px;\n    padding-right: 4px;\n    width: 60px;\n}\n\n.right.fixed_small.field {\n    padding-right: 12px;\n}\n\n.fixed_medium {\n    padding-left: 4px;\n    padding-right: 4px;\n    width: 90px;\n}\n\n.fixed_large {\n    padding-left: 4px;\n    padding-right: 4px;\n    width: 120px;\n}\n\n.fixed_huge {\n    padding-left: 4px;\n    padding-right: 4px;\n    width: 150px;\n}\n\n.greedy {\n    padding-left: 4px;\n    padding-right: 4px;\n    overflow: hidden;\n}\n\n.statement_number {\n    padding-top: 2px;\n    font-size: 14px;\n    position: relative;\n}\n\n.statement_left {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n.statement_center {\n    position: relative;\n    left: 0;\n    right: 0;\n    text-align: center;\n    font-weight: bold;\n}\n\n.statement_right {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
